import React from 'react';
import { ExpressTruckIcon } from '../../helpers/icon-utils';
import {
  showTodayOrTomorrow,
  formatDate,
  getPriorityDeliveryOption
} from '../../../components/helper/utils';
import {
  showEmptyShippingMessage
} from '../../helpers/pod-fulfillment-utils';
import { PodMessage } from '../PodMessage';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Badge, Typography } from '@one-thd/sui-atomic-components';
import { BOLT_BROWN_ICON_URL } from '../../../components/constants';

export const PriorityDeliveryOptions = ({
  product,
  showFasterPodSpacing = false,
  isNarrowPod = false,
  enablePodOnDemandDelivery = false
}) => {
  const priorityDeliveryOption = product?.fulfillment?.fulfillmentOptions
    ?.find((fo) => fo?.type === 'delivery')?.priorityDeliveryOptions|| [];

  const filterFasterDeliveryOption = getPriorityDeliveryOption(priorityDeliveryOption, enablePodOnDemandDelivery);

  if (!filterFasterDeliveryOption) {
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    return showFasterPodSpacing ? <div className="sm:sui-min-h-[27.5px]" /> : null;
  }

  const endDate = filterFasterDeliveryOption?.date;
  const timeline = filterFasterDeliveryOption?.timeline;
  if (filterFasterDeliveryOption?.timeline?.toLowerCase()?.includes('hour')) {
    const normalizedOnDemandTimeline = timeline?.replace(/s$/i, '');
    return (
      <div className="sui-mt-[6px]">
        <Badge
          color="success"
          variant="strong"
          size="base"
          data-testid="priority-delivery-badge"
          style={{ backgroundColor: '#FCD561' }}>
          <div className="sui-flex sui-py-2">
            <img
              src={BOLT_BROWN_ICON_URL}
              alt="bolt"
              width={16}
              height={16}
              data-testid="bolt-icon"
              className="sui-mr-1"
            />
            <div className="sui-mr-2" style={{ color: '#582301' }}>{normalizedOnDemandTimeline} Delivery</div>
          </div>
        </Badge>
      </div>
    );
  }
  
  const formattedEndDate = endDate && formatDate(endDate, false);
  const dateText = showTodayOrTomorrow(endDate, true, timeline, formattedEndDate, false);
  return (
    <PodMessage
      messageIcon={ExpressTruckIcon}
      messageType="Faster Delivery"
      isNarrowPod={isNarrowPod}
    >
      Get it {dateText}
    </PodMessage>
  );
};